module.exports = __webpack_public_path__ + "static/img/rank_261.6f63802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_261.png
// module id = CRo9
// module chunks = 0